/*
 Help System integration to OTHHUrlBuilder and OT oline help

*/
declare let OTHHUrlBuilder;
import { AWWebView, AWPage } from 'appworks-js';
import { _Device } from './device';
import { LocalizeService } from '../services/localize.service';
import { Util } from './utils.module';

export class _Help {
  private othh1: any = null;
  private version: string = null;
  private device: _Device = null;
  private localizer: LocalizeService;
  private isAddin: boolean;

  constructor(device: _Device) {
    this.version = this.toHelpVersion(device.version);
    this.device = device;
    this.isAddin = this.device.bIsAddin;
  }

  private toHelpVersion(eDocsVersion: string) {
    const helpVersion = `v${eDocsVersion.split('.').slice(0, 3).map(part => part.padStart(2, '0')).join('')}`;
    return helpVersion;
  }

  public setLocalizer(localizer: LocalizeService): void {
    this.localizer = localizer;
  }

  public show(): void {
    if (!this.othh1) {
      this.othh1 = new OTHHUrlBuilder({
        product: 'dmsu', //optional, default product
        version: this.version, //optional, default version
      });
    }
    const type: string = this.device.ui < 2 ? 'ofh1' : 'mhp';
    //Basic call, using default product and version, and adding module and type
    let url: string = this.othh1.buildHelpUrl(this.device.getUserLanguage(false),
      {
        documents: [
          { module: 'dmsu-h-ugd', version: this.version, topic: 'top-of-doc' }
        ]
      },
      {
        type
      }
    );
    const siteConfig = Util.RestAPI.siteConfigurations;
    url = !!siteConfig.helpUrl ? siteConfig.helpUrl : url;
    this.openURL(url, this.localizer.getTranslation('HEADER.HELP'));
  }

  public openURL(url: string, name?: string, event?: Event, defaultPopupFeatures?: string): any {
    let openWindow: any = null;
    if (url) {
      if (this.device.bIsElectron) {
        const webView: AWWebView = new AWWebView();
        openWindow = webView.open(url);
      } else if (this.device.bIsCordova) {
        const awPage: AWPage = new AWPage(pageResult => { }, error => { });
        openWindow = awPage.openModalExternalWebView(url, name, this.localizer.getTranslation('FORMS.BUTTONS.CANCEL'), null);
      } else if (this.isAddin) {
        openWindow = window.open(url, '_blank', defaultPopupFeatures);
      } else {
        openWindow = window.open(url, '_blank', defaultPopupFeatures);
      }
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
    }
    return openWindow;
  }

  public closeURL(openWindow?: any): void {
    if (openWindow) {
      if (this.device.bIsElectron) {
        const webView: AWWebView = openWindow;
        webView.close();
      } else if (this.device.bIsCordova) {
        const awPage: AWPage = openWindow;
        awPage.closeModalAppWebView();
      } else if (this.isAddin) {
        openWindow.close();
        openWindow = null;
      } else {
        openWindow.close();
      }
    }
  }
}
